import { createModel } from '@rematch/core';
import { selectors } from './selector';
import { RootState } from '../../store';
import { ProviderModel } from '../../models/provider';
import { storeData } from '../../utils/converter';
import {
    getProviders,
    getOtherProviders
} from '../../apis/provider';

export interface State {
    allIds: number[];
    byId: Dictionary<ProviderModel>;
    loading: Dictionary<boolean>;
}

export const providers = createModel<State>({
    state: {
        allIds: [],
        byId: {},
        loading: {}
    },
    reducers: {
        update: (
            state: State,
            data: ProviderModel[],
            loadingKey?: string
        ): State => {
            const byId = {
                ...state.byId,
                ...storeData(data, 'id')
            };
            return {
                ...state,
                allIds: Object.keys(byId)
                    .map(x => +x)
                    .sort((a, b) => a - b),
                byId: byId,
                ...loadingKey && {
                    loading: {
                        ...state.loading,
                        [loadingKey]: false
                    }
                }
            };
        },
        loading: (
            state: State,
            loadingKey: string,
            loading: boolean
        ): State => ({
            ...state,
            loading: {
                ...state.loading,
                [loadingKey]: loading
            }
        })
    },
    effects: () => ({
        async getProvidersAsync(ids: Undefinable<number>[], rootState: RootState) {
            const notExistedIds = selectors.getOtherProviderIds(rootState.providers, ids);
            if (notExistedIds.length > 0) {
                try {
                    const data = await getProviders(notExistedIds);
                    this.update(data);
                } catch (e) {
                    window.console.log(e);
                }
            }
        },
        async getOtherProvidersAsync(_: {}, rootState: RootState) {
            const existedIds = selectors.getProviderIds(rootState.providers);
            try {
                const data = await getOtherProviders(existedIds);
                this.update(data);
            } catch (e) {
                window.console.log(e);
            }
        }
    })
});
